var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{attrs:{"d":"M7,2V13H10V22L17,10H13L17,2H7Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }